import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { useBiClickLogger } from '../hooks/useBiClickLogger';
const BiButton = (_param)=>{
    var { biData , innerRef , stopPropagation , disabled  } = _param, props = _object_without_properties(_param, [
        "biData",
        "innerRef",
        "stopPropagation",
        "disabled"
    ]);
    const { setTrackingRef  } = useBiClickLogger(biData, stopPropagation);
    return /*#__PURE__*/ React.createElement("button", _extends({
        /*
        Some screen readers don't pick up that a button is disabled
        when only `disable` is set, so use aria-disabled as well
      */ disabled: disabled,
        "aria-disabled": disabled
    }, props, {
        ref: (node)=>{
            setTrackingRef(node);
            innerRef && innerRef(node);
        }
    }));
};
BiButton.displayName = 'BiButton';
export default BiButton;
